import { FileCardOptionsTypeEnum } from "app/components/MediaUploader/types";
import React from "react";
import Dropdown from "../Dropdown";
import { Menu } from "../Icons";
import { options } from "./data";

export interface IFileActions {
  onRename: () => void;
  onCopy: () => void;
  onDownload: () => void;
  onDelete: () => void;
}

interface Props {
  actions: IFileActions;
}

const Actions: React.FC<Props> = ({ actions }) => {
  const { onCopy, onDelete, onDownload, onRename } = actions;
  // map to Dropdown items and wire actions via switch
  const MenuItems = options.map((ele) => ({
    label: (
      <div className="flex items-center justify-between gap-1.5 rounded-md transition-colors">
        <div className="flex items-center gap-2">
          {ele.icon}
          <span className="text-sm font-normal text-black">{ele.label}</span>
        </div>
      </div>
    ),
    action: () => {
      switch (ele.type) {
        case FileCardOptionsTypeEnum.IS_EDIT:
          onRename();
          break;
        case FileCardOptionsTypeEnum.DOWNLOAD:
          onDownload();
          break;
        case FileCardOptionsTypeEnum.COPY_URL:
          onCopy();
          break;
        case FileCardOptionsTypeEnum.IS_REMOVE:
          onDelete();
          break;
        default:
          break;
      }
    },
  }));
  return (
    <div className="relative">
      <Dropdown
        trigger={
          <button className="opacity-0 group-hover:opacity-100 w-6 h-6 flex items-center justify-center focus:outline-none  data-[state=open]:opacity-50  ">
            <Menu color="#FFF"/>
          </button>
        }
        menuItems={MenuItems}
        align="end"
        className="!w-[150px]"
      />
    </div>
  );
};

export default Actions;
